// extracted by mini-css-extract-plugin
export default {"card":"DiscordLink_card__SzN1j","spinner":"DiscordLink_spinner__-1AdO","error":"DiscordLink_error__2FDxy","spin":"DiscordLink_spin__XJo6p","content":"DiscordLink_content__I+LgM"};